import React, { ReactNode } from 'react';
import { PERMISSIONS, ProtectedRoute } from '../auth';

/**
 * Requires both permissions: `ProtectedRoute` grants on ANY permission of a list,
 * so each one gets its own nested check.
 */
export function QaKnowledgeBaseGate({ children }: { children: ReactNode }) {
  return (
    <ProtectedRoute
      requiredPermission={PERMISSIONS.agent.qa.knowledgeBase.view}
      denyBehavior="inline"
    >
      <ProtectedRoute requiredPermission={PERMISSIONS.agent.kb.view} denyBehavior="inline">
        {children}
      </ProtectedRoute>
    </ProtectedRoute>
  );
}
